// extracted by mini-css-extract-plugin
export default {"time":"AsvSkk14","timeWarning":"CZBR69BT"};